// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Tim_wrapper__2oC-M {
  padding: 50px 100px;
}

.Tim_grid__LiBrk {
  margin-top: 50px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  column-gap: 30px;
}

.Tim_title__Tvf2T,
.Tim_doc__It033 {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.Tim_doc__It033 {
  margin-bottom: 35px;
}

.Tim_p__oQN4e {
  width: 32%;
  font-size: 16px;
  font-family: "Open Sans";
  font-weight: 400;
  color: #747474;
}

.Tim_spec__VVXmO {
  width: 75%;
  font-size: 16px;
  font-family: "Open Sans";
  font-weight: 400;
  color: #747474;
  margin-block-start: 10px;
}

.Tim_h1__O\\+7xv {
  font-size: 36px;
  font-family: "Lato";
  font-weight: 800;
  color: #090446;
}

.Tim_h2__FaTlI {
  font-size: 20px;
  font-family: "Open Sans";
  font-weight: 700;
  color: #47a9f4;
  margin-block-end: 0;
}

@media screen and (max-width: 1000px) {
  .Tim_grid__LiBrk {
    grid-template-columns: repeat(2, 1fr);
  }
  .Tim_p__oQN4e {
    width: 50%;
  }
}

@media screen and (max-width: 710px) {
  .Tim_h2__FaTlI {
    font-size: 18px;
  }
  .Tim_wrapper__2oC-M {
    padding: 50px 50px;
  }
}

@media screen and (max-width: 650px) {
  .Tim_p__oQN4e {
    width: 70%;
  }
  .Tim_grid__LiBrk {
    grid-template-columns: repeat(1, 1fr);
  }
}

@media screen and (max-width: 400px) {
  .Tim_p__oQN4e {
    width: 85%;
  }
  .Tim_spec__VVXmO {
    width: 85%;
    font-size: 16px;
  }
  .Tim_wrapper__2oC-M {
    padding: 50px 30px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Tim/Tim.module.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,wBAAwB;EACxB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,wBAAwB;EACxB,gBAAgB;EAChB,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE;IACE,qCAAqC;EACvC;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;IACV,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".wrapper {\n  padding: 50px 100px;\n}\n\n.grid {\n  margin-top: 50px;\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  column-gap: 30px;\n}\n\n.title,\n.doc {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n}\n\n.doc {\n  margin-bottom: 35px;\n}\n\n.p {\n  width: 32%;\n  font-size: 16px;\n  font-family: \"Open Sans\";\n  font-weight: 400;\n  color: #747474;\n}\n\n.spec {\n  width: 75%;\n  font-size: 16px;\n  font-family: \"Open Sans\";\n  font-weight: 400;\n  color: #747474;\n  margin-block-start: 10px;\n}\n\n.h1 {\n  font-size: 36px;\n  font-family: \"Lato\";\n  font-weight: 800;\n  color: #090446;\n}\n\n.h2 {\n  font-size: 20px;\n  font-family: \"Open Sans\";\n  font-weight: 700;\n  color: #47a9f4;\n  margin-block-end: 0;\n}\n\n@media screen and (max-width: 1000px) {\n  .grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n  .p {\n    width: 50%;\n  }\n}\n\n@media screen and (max-width: 710px) {\n  .h2 {\n    font-size: 18px;\n  }\n  .wrapper {\n    padding: 50px 50px;\n  }\n}\n\n@media screen and (max-width: 650px) {\n  .p {\n    width: 70%;\n  }\n  .grid {\n    grid-template-columns: repeat(1, 1fr);\n  }\n}\n\n@media screen and (max-width: 400px) {\n  .p {\n    width: 85%;\n  }\n  .spec {\n    width: 85%;\n    font-size: 16px;\n  }\n  .wrapper {\n    padding: 50px 30px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `Tim_wrapper__2oC-M`,
	"grid": `Tim_grid__LiBrk`,
	"title": `Tim_title__Tvf2T`,
	"doc": `Tim_doc__It033`,
	"p": `Tim_p__oQN4e`,
	"spec": `Tim_spec__VVXmO`,
	"h1": `Tim_h1__O+7xv`,
	"h2": `Tim_h2__FaTlI`
};
export default ___CSS_LOADER_EXPORT___;
